import { render, staticRenderFns } from "./TgShopItem.vue?vue&type=template&id=7c574394&"
import script from "./TgShopItem.vue?vue&type=script&lang=js&"
export * from "./TgShopItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports